import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "text-center"
}
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = { key: 5 }
const _hoisted_7 = {
  key: 6,
  class: "text-center"
}
const _hoisted_8 = {
  key: 7,
  class: "text-center"
}
const _hoisted_9 = {
  key: 8,
  class: "text-center"
}
const _hoisted_10 = {
  key: 9,
  class: "text-center"
}
const _hoisted_11 = {
  key: 10,
  class: "text-center"
}
const _hoisted_12 = {
  key: 11,
  class: "text-center"
}
const _hoisted_13 = {
  key: 12,
  class: "text-center"
}
const _hoisted_14 = {
  key: 13,
  class: "text-center"
}
const _hoisted_15 = {
  key: 14,
  class: "text-center"
}
const _hoisted_16 = {
  key: 15,
  class: "text-center"
}
const _hoisted_17 = {
  key: 16,
  class: "text-center"
}
const _hoisted_18 = {
  key: 17,
  class: "text-center"
}
const _hoisted_19 = {
  key: 18,
  class: "text-center"
}
const _hoisted_20 = {
  key: 19,
  class: "text-center"
}
const _hoisted_21 = {
  class: "text-center",
  style: {"min-width":"160px"}
}
const _hoisted_22 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_Document = _resolveComponent("Document")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "px-0 pt-4 pb-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "auto" }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("h2", { class: "ml-2" }, "A nouveaux à extourner", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.accountingPeriod && _ctx.accountingPeriod.closed)
        ? (_openBlock(), _createBlock(_component_v_card_title, {
            key: 0,
            class: "px-0 py-2"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("h4", { class: "primary--text" }, "Période Clôturée", -1)
            ])),
            _: 1
          }))
        : (!_ctx.previousAccountingPeriod)
          ? (_openBlock(), _createBlock(_component_v_card_title, {
              key: 1,
              class: "px-0 py-2"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("h1", { class: "pa-2" }, "N-1 n'a pas été créée dans bobbee", -1),
                _createElementVNode("h2", { class: "pt-4 px-2 pb-2" }, "Si elle existe, il faut :", -1),
                _createElementVNode("h3", { class: "pa-2" }, "- la créer", -1),
                _createElementVNode("h3", { class: "pa-2" }, " - importer le FEC (indispensables à la reprise automatiques des AN) ", -1),
                _createElementVNode("h3", { class: "pa-2" }, "- la clôturer", -1)
              ])),
              _: 1
            }))
          : (_ctx.previousAccountingPeriod && !_ctx.previousAccountingPeriod.closed)
            ? (_openBlock(), _createBlock(_component_v_card_title, {
                key: 2,
                class: "px-0 py-2"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("h2", {
                    class: "ml-2",
                    style: {"color":"#e1be7a"}
                  }, " Dans \"Mon dossier\" - \"Exercices\" - N-1 doit être clôturé et les reports à nouveau calculés ", -1)
                ])),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px","border":"1px #ededed solid"},
                  class: "pa-4 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "px-4 d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "title font-weight-bold"
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode(" Grand Livre N - Comptes de régularisation : lettrages à compléter avant d'analyser les extournes à effectuer ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: _ctx.show3112NGL ? '$fa-chevron-up' : '$fa-chevron-down',
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show3112NGL = !_ctx.show3112NGL)),
                                      "data-cy": "CheckReversal-arrow"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger }, {
                                default: _withCtx(() => [
                                  (_ctx.accountingPeriod)
                                    ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                        key: 0,
                                        companyId: _ctx.companyId,
                                        accountingPeriodId: _ctx.accountingPeriod.id,
                                        accountableAccountFilter: _ctx.tpaas,
                                        hideOptions: true,
                                        inNm1: false,
                                        hideBodyAppend: "true",
                                        onQueryDone: _ctx.onQueryDone
                                      }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "onQueryDone"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.show3112NGL]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.carryBackDocuments || !_ctx.carryBackDocuments.length)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 0,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px","border":"1px #ededed solid"},
                      class: "pa-4 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "px-4 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "11",
                              class: "title font-weight-bold"
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode(" Aucun document N-1 contenant des comptes tiers de régularisation ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_card, {
                      key: 1,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px","border":"1px #ededed solid"},
                      class: "pa-4 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "px-4 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "auto",
                              class: "title font-weight-bold"
                            }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode(" Documents N-1 contenant des comptes tiers de régularisation ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "auto",
                              class: "align-center pl-8"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.allAlsReconciliatedInN_1WithReversalACR)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      location: "bottom"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps({
                                          color: "error",
                                          class: "align-center"
                                        }, props, { icon: "$fa-exclamation-triangle" }), null, 16)
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[13] || (_cache[13] = _createElementVNode("h3", null, " Les lignes en rouge signalent des écritures extournées en N pour, ensuite, avoir été lettrées sur un exercice précédent. N'ayant plus d'AN, il faut annuler l'extourne. ", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showGroupedReversalBtn)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      dense: "",
                                      rounded: "",
                                      elevation: "0",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateReversalsLoop()))
                                    }, {
                                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                                        _createTextVNode(" Extournes groupées ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_menu, { "offset-y": "" }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                      class: "mx-1",
                                      color: "secondary"
                                    }), null, 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, null, {
                                      default: _withCtx(() => [
                                        (_ctx.showGroupedAnnulsBtn && !_ctx.accountingPeriod.closed)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.devalidateReversalsLoop()))
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "small" }, {
                                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                    _createTextVNode(" $oss-trash ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                    _createTextVNode("Tout supprimer")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              disabled: ""
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "small" }, {
                                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                    _createTextVNode(" $oss-trash ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                    _createTextVNode(" Tout supprimer ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                        _ctx.showReversalTable ? '$fa-chevron-up' : '$fa-chevron-down'
                                    ,
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showReversalTable = !_ctx.showReversalTable))
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expand_transition, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_v_card_text, { class: "px-0 pb-0 pt-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_data_table, {
                                  headers: _ctx.carryBackDocsALsHeaders,
                                  items: _ctx.carryBackDocuments,
                                  "multi-sort": "",
                                  loading: _ctx.loading,
                                  class: "table",
                                  style: {"border":"1px #ededed solid"},
                                  "items-per-page": -1
                                }, {
                                  "no-data": _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createTextVNode("Aucun compte de régularisation mouvementé")
                                  ])),
                                  item: _withCtx((props) => [
                                    _createElementVNode("tr", {
                                      class: _normalizeClass(props.item.document.allAlsReconciliatedInN_1WithReversalACR ? 'text-error' : undefined )
                                    }, [
                                      (props.item.document.date)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(_ctx.formatDate(props.item.document.date)), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_2, "-")),
                                      (props.item.document.type)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(_ctx.$t("document.type." + props.item.document.type)), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_4, "-")),
                                      (props.item.document.displayName)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                                            (props.item.documentId)
                                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                  key: 0,
                                                  icon: "$remove_red_eye",
                                                  color: "primary",
                                                  onClick: _withModifiers(($event: any) => {
                                                _ctx.selectedDocumentId = props.item.documentId;
                                                _ctx.showDocument = true;
                                            }, ["stop"]),
                                                  size: "x-small"
                                                }, null, 8, ["onClick"]))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(props.item.document.displayName), 1)
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_6, "-")),
                                      (props.item.reversalAccountsString)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(props.item.reversalAccountsString), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_8, "-")),
                                      (props.item.document.allTPAAReconciliated)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_9, " Lettré "))
                                        : (
                                            !props.item.document.allTPAAReconciliated &&
                                            (props.item.document.reconciliatedAaN_1.length ||
                                                props.item.document.reconciliatedAaN.length)
                                        )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_10, " Partiellement lettré "))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_11, "-")),
                                      (
                                            props.item.document &&
                                            props.item.document.reconciliatedAaN_1.length
                                        )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(props.item.document.reconciliatedAaN_1.length), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_13, "-")),
                                      (
                                            props.item.document &&
                                            props.item.document.reconciliatedAaN.length
                                        )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(props.item.document.reconciliatedAaN.length), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_15, "-")),
                                      (
                                            props.item.document &&
                                            props.item.document.existingReversalAccounts.length
                                        )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(props.item.document.reconciliatedAaN_1.length +
                                            props.item.document.reconciliatedAaN.length) + " / " + _toDisplayString(props.item.document.existingReversalAccounts.length), 1))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_17, "-")),
                                      (
                                            props.item.auditCheckResult &&
                                            props.item.auditCheckResult.results &&
                                            props.item.auditCheckResult.results.length
                                        )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: "$remove_red_eye",
                                              color: "primary",
                                              class: "mr-2",
                                              onClick: _withModifiers(($event: any) => {
                                                _ctx.selectedDocumentId =
                                                    props.item.auditCheckResult.results[0].id;
                                                _ctx.showDocument = true;
                                            }, ["stop"]),
                                              size: "x-small"
                                            }, null, 8, ["onClick"]),
                                            _cache[20] || (_cache[20] = _createTextVNode(" Extourne N "))
                                          ]))
                                        : (props.item.ignored)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_19, " Ignoré "))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_20, "A vérifier")),
                                      _createElementVNode("td", _hoisted_21, [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            (!props.item.auditCheckResult)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "6",
                                                  class: "d-flex align-center justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (
                                                        _ctx.accountingPeriod.closed &&
                                                        !props.item.ignored
                                                    )
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          disabled: "",
                                                          rounded: "",
                                                          elevation: "0",
                                                          size: "x-small"
                                                        }, {
                                                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                            _createTextVNode(" Ignorer ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (
                                                        !props.item.ignored &&
                                                        !props.item.auditCheckResult
                                                    )
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 1,
                                                            rounded: "",
                                                            elevation: "0",
                                                            onClick: ($event: any) => {
                                                        props.item.ignored = true;
                                                        _ctx.validateReversals(props.item);
                                                    },
                                                            size: "x-small"
                                                          }, {
                                                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                              _createTextVNode(" Ignorer ")
                                                            ])),
                                                            _: 2
                                                          }, 1032, ["onClick"]))
                                                        : (_openBlock(), _createElementBlock("h3", _hoisted_22))
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true),
                                            (!props.item.auditCheckResult)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 1,
                                                  cols: "6",
                                                  class: "d-flex align-center justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.accountingPeriod.closed)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          disabled: "",
                                                          rounded: "",
                                                          elevation: "0",
                                                          size: "x-small"
                                                        }, {
                                                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                            _createTextVNode(" Exercice clôturé ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (!props.item.auditCheckResult)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 1,
                                                            rounded: "",
                                                            elevation: "0",
                                                            onClick: ($event: any) => (_ctx.validateReversals(props.item)),
                                                            size: "x-small"
                                                          }, {
                                                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                              _createTextVNode(" Extourner ")
                                                            ])),
                                                            _: 2
                                                          }, 1032, ["onClick"]))
                                                        : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 2,
                                                  cols: "12",
                                                  class: "d-flex align-center justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.accountingPeriod.closed)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          disabled: "",
                                                          rounded: "",
                                                          elevation: "0",
                                                          size: "x-small"
                                                        }, {
                                                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                            _createTextVNode(" Annuler ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          color: "primary",
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: ($event: any) => (_ctx.devalidateReversals(props.item)),
                                                          size: "x-small"
                                                        }, {
                                                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                            _createTextVNode(" Annuler ")
                                                          ])),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ], 2)
                                  ]),
                                  _: 1
                                }, 8, ["headers", "items", "loading"])
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.showReversalTable]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ], 64)),
      (_ctx.showDocument && _ctx.selectedDocumentId)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 4,
            modelValue: _ctx.showDocument,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDocument) = $event)),
            withoutHeader: true,
            transition: "dialog-bottom-transition",
            "min-width": "90vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    style: {"overflow-y":"auto"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Document, {
                        mode: 'GeneralLedger',
                        companyId: _ctx.selectedCompany.id,
                        id: _ctx.selectedDocumentId,
                        "dark-mode": true,
                        onOpenReconciliation: _ctx.openReconciliation
                      }, null, 8, ["companyId", "id", "onOpenReconciliation"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}